<template>
  <div class="client-view">
    <card>
      <h4 class="card-title">Información básica del usuario</h4>
      <form>
        <div class="inputs">
          <div class="input-left">
            <div class="form-group">
              <label for="suscriberId">Suscriber ID</label>
              <input  type="text" readonly :value="userInfo.SubscrId || 0" id="suscriberId" />
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" :value="userInfo.Email" @keyup="(e)=>{fillUserInfoUpdate(e,'Email')}" id="email" />
            </div>
          </div>
          <div class="input-right">
            <div class="form-group">
              <label for="clientName">Rol</label>
              <input type="" readonly :value="userInfo.Role" id="clientName" />
            </div>
            
            <div class="form-group">
              <label for="userName">Usuario</label>
              <input type="text" :value="userInfo.UserName" @keyup="(e)=>{fillUserInfoUpdate(e,'UserName')}" id="userName" />
            </div>
          </div>
        </div>
        <small class="password-no-valid" v-if="isFieldBlank">Los campos no pueden estar vacios</small>
        <button class="btn btn-primary" type="button" @click="()=>{saveUserInfo()}">GUARDAR</button>
      </form>
    </card>

    <card>
      <h4 class="card-title">Cambiar contraseña</h4>
      <form>
        <div class="inputs">
          <div class="input-left">
            <div class="form-group">
              <label for="password">Contraseña</label>
              <input type="password" @keyup="(e)=>{fillUserPasswordUpdate(e); confirmPassword();isOldPassword = validateSameOldPassword(e.target.value)}" id="password" />
            </div>
          </div>
          <div class="input-right">
            
            <div class="form-group">
              <label for="passwordConfirm">Confirmar contraseña</label>
              <input type="password" @keyup="(e)=> {passwordConfirm = e.target.value; confirmPassword();}" id="passwordConfirm" />
            </div>
          </div>
        </div>
        <small class="password-no-valid" v-if="isPasswordBlank">Los campos no pueden estar vacios</small>
        <small class="password-no-valid" v-if="!isPasswordValidated">Las contraseñas no coinciden</small>
        <small class="password-no-valid" v-if="isOldPassword">La contraseña no puede ser igual a la anterior</small>
        <button class="btn btn-primary" type="button" @click="(e)=>{updateUserPassword()}">ACTUALIZAR CONTRASEÑA</button>
      </form>
    </card>
  </div>
</template>
<script>
// import FgInput from "@/components/Inputs/Input.vue";
import userService from "../../services/Fase2/profile";
import Swal from "sweetalert2";
import {compareSync} from 'bcryptjs';
export default {
  name: "client-managment",
  data() {
    return {
      userId: "",
      isFieldBlank: false,
      isPasswordBlank: false,
      passwordConfirm: "",
      isPasswordValidated: true,
      isOldPassword: false,
      userInfo: {
        BusinessUnitId: 1,
        Email: "",
        Password: "",
        Role: "",
        SubscrId: null,
        UserId: "",
        UserName: ""
      },
      UserInfoUpdate: {
        UserName: "",
        Email: "",
        Status: true
      },
      UserPasswordUpdate:{
        Password: "",
      }
    };
  },
  async created() {
    this.$store.commit("FillClient", "");
    const email = localStorage.getItem("userEmail") || localStorage.getItem("userName") || localStorage.getItem("subscriberId");
    const businessUnitId = localStorage.getItem("businessUnitId");
    

    const profile = await new userService(this).getUserInfo(
      decodeURIComponent(email),
      businessUnitId
    );

    if(profile){
      this.userInfo = profile;
      this.userInfo.BusinessUnitId = profile.BusinessUnitId;
      this.userInfo.Email = profile.Email;
      this.userInfo.Role = profile.Role;
      this.userInfo.SubscrId = profile.SubscrId;
      this.userInfo.UserId = profile.UserId;
      this.userInfo.UserName = profile.UserName;
      this.userInfo.password = profile.Password;
      this.UserInfoUpdate.UserName = await profile.UserName;
      this.UserInfoUpdate.Email = await profile.Email;
    }

    this.userId = this.userInfo.UserId;

  },
  methods:{
    saveUserInfo: async function(){
      try{
        if(this.UserInfoUpdate.Email && this.UserInfoUpdate.UserName){
          this.isFieldBlank = false;
          const status = await new userService(this).updateUserInfo(this.userId,this.UserInfoUpdate);
          if(status){
            this.successfulMessage("Datos Actualizados Satisfactoriamente")
          }
          this.logout();
        }

        this.isFieldBlank = true;

      }catch(e){
        console.log(e);
      }
    },
    updateUserPassword: async function(){
      try{
        const isValidPassword = this.confirmPassword()

        if(isValidPassword){
          const status = await new userService(this).updateUserPassword(this.userId,this.UserPasswordUpdate);
          if(status){
            this.successfulMessage("Contraseña Actualizada Satisfactoriamente")
            this.logout();
          }
        }

      }catch(e){
        console.log(e);
      }
    },
    fillUserInfoUpdate: function(e,property){
      let value = e.target.value;
      this.UserInfoUpdate[property] = value;
    },
    fillUserPasswordUpdate: function(e){
      let value = e.target.value;
      this.UserPasswordUpdate.Password = value;
    },
    validateSameOldPassword: function(password){
      return compareSync(password,this.userInfo.Password);
      
    },
    confirmPassword: function(){
      let password = this.UserPasswordUpdate.Password;
      let passConfirmation = this.passwordConfirm;

      if(!password){
        this.isPasswordBlank = true;
        return false
      }else{
        this.isPasswordBlank = false;
      }

      if(password != passConfirmation){
        this.isPasswordValidated = false;
        return false
      }else{
        this.isPasswordValidated = true;
      }

      if(this.isOldPassword){
        return false;
      }
      
      return true
    },
    successfulMessage: function(message){
      Swal.fire({
        position: "center",
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500
      });
    },
    logout: async function(){
      localStorage.removeItem("user-token");
      localStorage.removeItem("token-expiration");
      this.$router.push({ name: "login" });
    }
  }
  // components: {
  //   FgInput
  // }
};
</script>
<style lang="scss" scoped>
.client-view {
  max-width: 1000px;
  margin: 0 auto;
  .card-title {
    margin-bottom: 10px;
  }
}
.password-no-valid{
  color: red;
  display: block;
  margin: 10px 0;
}
[readonly], [disabled]{
  background-color: #f6f6f6;
  color: #797979;
  border-color: #c8c8c8;
}

@include respond-above(md) {
  .inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
}
</style>
